import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';

import { guidEmpty, Roles } from '../../common/';
import { GuidHelper } from '../../framework';
import { ActionType, ComponentDefinition, Dictionary, IAction, IDatePickerDates, KeyValuePair } from '../../models/';
import { SendMailAction } from '../../models/triggerActions/SendMailAction';
import { IAuthorizationService, IDateRangeService, IHtmlMailService } from '../../services/';

class WtTriggerMailButton {
    guidEmpty = guidEmpty;
    hasRoles: boolean;
    isLoading: boolean;
    mailGuid: string;
    mails: KeyValuePair<string, string>[];
    modalId: string;
    range: IDatePickerDates;

    readonly actions: Dictionary<IAction>;
    readonly dashboardGuid: string;
    readonly format: string;
    readonly groupGuid: string;

    static $inject = ['authorizationService', 'htmlMailService', 'dateRangeService'];
    constructor(
        private _authorizationService: IAuthorizationService,
        private _htmlMailService: IHtmlMailService,
        private _dateRangeService: IDateRangeService
    ) {
        this.modalId = GuidHelper.getGuid();
        this.initRange();
    }

    $onInit() {
        this.hasRoles = this._authorizationService.isInRoles([Roles.operator, Roles.master, Roles.engineer]);
        this.buildMailList();
    }

    $onChanges(changes: angular.IOnChangesObject) {
        this.buildMailList();
    }

    click() {
        const begin = this.range.startDate.toISOString();
        const end = this.range.endDate.toISOString();
        this.isLoading = true;
        // #49123 : send for all groups
        this._htmlMailService
            .trigger(this.mailGuid, guidEmpty, begin, end)
            .finally(() => this.isLoading = false);
    }

    openModal() {
        this.initRange();
        $(`#${this.modalId}`).modal('show');
    }

    private initRange() {
        this.range = {
            startDate: moment(this._dateRangeService.beginDate()),
            endDate: moment(this._dateRangeService.endDate())
        };
    }

    private buildMailList() {
        if (this.actions && this.dashboardGuid) {
            // retreive mail sorted by alpha on subject
            const mails = Object
                .keys(this.actions)
                .map(k => this.actions[k])
                .filter(a => a.type === ActionType.SendMail)
                .map(a => a as SendMailAction)
                .filter(m => _.some(m.emailDefinition.dashboards, d => d.guid === this.dashboardGuid))
                .sort((a, b) => a.emailDefinition.subject.localeCompare(b.emailDefinition.subject));
            // Assign list using mail subject as requested in #39863
            this.mails = mails.map(m => { return { key: m.guid, value: m.emailDefinition.subject }; });
            // Preselect first choice
            this.mailGuid = mails.length > 0
                ? mails[0].guid
                : guidEmpty;
        }
    }
}

export const wtTriggerMailButton: ComponentDefinition = {
    componentId: 'wtTriggerMailButton',
    controller: WtTriggerMailButton,
    template: require('./triggerMailButton.component.html'),
    controllerAs: 'vm',
    bindings: {
        actions: '<',
        dashboardGuid: '<',
        format: '<?',
        groupGuid: '<'
    }
};